import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const HRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="HR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#3D58DB"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path fill="#E31D1C" d="M5.038 3.199h5.7v2h-5.7z" />
        <Path
          fill="#F7FCFF"
          stroke="#E31D1C"
          strokeWidth={0.563}
          d="M10.39 4.48c.009.384.012 1.055.012 1.701 0 .417-.002.818-.003 1.115l-.001.357-.001.098v.016l-.012.063a2.73 2.73 0 0 1-.407.95C9.631 9.287 9 9.808 7.825 9.808c-1.174 0-1.774-.521-2.093-1.023a2.583 2.583 0 0 1-.37-1.01V7.747l-.001-.099-.005-.355-.013-1.11c-.007-.635-.012-1.305-.015-1.702h5.062Z"
        />
        <Mask
          id="c"
          width={6}
          height={7}
          x={5}
          y={4}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.563}
            d="M10.39 4.48c.009.384.012 1.055.012 1.701 0 .417-.002.818-.003 1.115l-.001.357-.001.098v.016l-.012.063a2.73 2.73 0 0 1-.407.95C9.631 9.287 9 9.808 7.825 9.808c-1.174 0-1.774-.521-2.093-1.023a2.583 2.583 0 0 1-.37-1.01V7.747l-.001-.099-.005-.355-.013-1.11c-.007-.635-.012-1.305-.015-1.702h5.062Z"
          />
        </Mask>
        <G mask="url(#c)">
          <Path
            fill="#F50100"
            d="M6.304 9.875H5.249v-1.07h1.055v1.07Zm2.11 0H7.358v-1.07h1.054v1.07Zm2.109 0H9.468v-1.07h1.055v1.07Zm-3.164-1.07H6.304V7.732h1.055v1.071Zm2.109 0H8.413V7.732h1.055v1.071ZM6.304 7.732H5.249V6.662h1.055v1.07Zm2.11 0H7.358V6.662h1.054v1.07Zm2.109 0H9.468V6.662h1.055v1.07ZM7.359 6.662H6.304v-1.07h1.055v1.07Zm2.109 0H8.413v-1.07h1.055v1.07Zm-3.164-1.07H5.249V4.52h1.055v1.071Zm2.11 0H7.358V4.52h1.054v1.071Zm2.109 0H9.468V4.52h1.055v1.071Z"
          />
        </G>
        <Path
          fill="#56C6F5"
          fillRule="evenodd"
          stroke="#fff"
          strokeWidth={0.4}
          d="M5.227 4.081s.326-.174.604-.264c.278-.09.498-.139.498-.139l-.414-1.526-.829-.31-.47.775.61 1.464Z"
          clipRule="evenodd"
        />
        <Path
          fill="#fff"
          d="m5.09 3.245.096-.046c.098.21.228.276.406.21.181-.068.255-.196.23-.4l.104-.013c.032.252-.07.428-.298.513-.232.087-.417-.006-.537-.264Z"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="m5.316 2.77-.09.056a.027.027 0 0 1-.041-.028l.02-.105-.093-.051a.027.027 0 0 1 .004-.05l.101-.034-.002-.106c0-.024.027-.037.045-.021l.08.07.091-.055a.027.027 0 0 1 .04.028l-.02.105.093.05a.027.027 0 0 1-.004.05l-.1.035.001.106a.027.027 0 0 1-.045.021l-.08-.07Z"
          clipRule="evenodd"
        />
        <Path
          fill="#56C6F5"
          fillRule="evenodd"
          stroke="#fff"
          strokeWidth={0.4}
          d="M7.27 3.538s.279-.025.57-.02c.293.006.54.009.54.009l.143-1.505-.626-.566-.696.58.07 1.502Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M7.875 3.293c.241 0 .264-.26.264-.438-.061-.099-.049-.17-.246-.17-.198 0-.22.06-.278.17 0 .177.019.438.26.438ZM8.147 2.556c.24 0 .264-.26.264-.437-.062-.099-.05-.17-.247-.17-.198 0-.22.06-.278.17 0 .177.02.437.26.437ZM7.62 2.556c.24 0 .263-.26.263-.437-.061-.099-.049-.17-.246-.17-.198 0-.22.06-.278.17 0 .177.019.437.26.437Z"
          clipRule="evenodd"
        />
        <Path
          fill="#2E42A5"
          stroke="#fff"
          strokeWidth={0.4}
          d="m6.608 1.368.68.484.077.053.008.093.126 1.462.017.209-.208.008h-.012l-.033.002a8.01 8.01 0 0 0-.413.035 2.72 2.72 0 0 0-.305.069 5.68 5.68 0 0 0-.128.037l-.037.012-.01.003h-.003l-.195.062-.058-.196-.432-1.472-.034-.111.081-.084.62-.642.119-.124.14.1Z"
        />
        <Mask
          id="d"
          width={3}
          height={4}
          x={5}
          y={1}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.4}
            d="m6.608 1.368.68.484.077.053.008.093.126 1.462.017.209-.208.008h-.012l-.033.002a8.01 8.01 0 0 0-.413.035 2.72 2.72 0 0 0-.305.069 5.68 5.68 0 0 0-.128.037l-.037.012-.01.003h-.003l-.195.062-.058-.196-.432-1.472-.034-.111.081-.084.62-.642.119-.124.14.1Z"
          />
        </Mask>
        <G fill="#C51918" mask="url(#d)">
          <Path d="m6.218 3.319-.125-.295c.269-.118.723-.19 1.202-.218l.018.32c-.445.027-.865.092-1.095.193ZM6.007 2.605l-.125-.295c.269-.118.847-.213 1.325-.241l.018.32c-.444.027-.988.116-1.218.216Z" />
        </G>
        <Path
          fill="#2E42A5"
          stroke="#fff"
          strokeWidth={0.4}
          d="m9.096 1.368-.681.484-.076.053-.008.093-.126 1.462-.018.209.21.008h.011l.033.002a7.95 7.95 0 0 1 .412.035c.083.011.202.04.306.069l.128.037.038.012.01.003h.002l.2.063.053-.201.399-1.475.028-.105-.074-.081-.584-.64-.12-.13-.143.102Z"
        />
        <Mask
          id="e"
          width={4}
          height={4}
          x={7}
          y={1}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.4}
            d="m9.096 1.368-.681.484-.076.053-.008.093-.126 1.462-.018.209.21.008h.011l.033.002a7.95 7.95 0 0 1 .412.035c.083.011.202.04.306.069l.128.037.038.012.01.003h.002l.2.063.053-.201.399-1.475.028-.105-.074-.081-.584-.64-.12-.13-.143.102Z"
          />
        </Mask>
        <G mask="url(#e)">
          <Path
            fill="#FECA00"
            fillRule="evenodd"
            d="M9.199 3.233s.147-.082.168-.22c.021-.137.249-.307.135-.287-.114.02-.049.036-.213 0-.165-.036-.378-.06-.378-.161s.106-.182.02-.182c-.087 0-.272-.095-.235-.022.037.073-.085-.01-.024.142.061.152-.013.305.024.346.037.04-.024.237-.024.237s.022.074.062-.036c.04-.11.125-.187.082-.094-.043.094-.098.316-.049.277a.348.348 0 0 0 .098-.183c0-.036.123-.18.123-.071 0 .107-.116.192-.058.192s.091.023.128-.085c.036-.107.125-.179.161-.107.037.071.029.067-.02.16-.049.094 0 .094 0 .094Z"
            clipRule="evenodd"
          />
          <Path
            fill="#C51918"
            d="M9.152 3.213c.03 0 .056.025.056.055s-.025.056-.056.056a.057.057 0 0 1-.057-.056c0-.03.026-.055.057-.055Zm-.366-.085c.031 0 .056.025.056.055s-.025.056-.056.056a.056.056 0 0 1-.056-.056c0-.03.025-.055.056-.055Zm.19-.004c.03 0 .055.025.055.055s-.024.056-.055.056a.057.057 0 0 1-.057-.056c0-.03.026-.055.057-.055ZM8.68 3.02c.03 0 .055.026.056.056 0 .03-.025.055-.056.056a.056.056 0 0 1-.057-.056c0-.03.026-.056.057-.056Zm.386-.721a.72.72 0 0 1 .133.083l.01.006c.073.052.112.073.136.073v.107c-.055 0-.102-.026-.196-.092l-.01-.007a.673.673 0 0 0-.114-.072c-.044-.018-.1-.008-.172.036l-.055-.091c.098-.06.189-.077.268-.043Z"
          />
        </G>
        <Path
          fill="#56C6F5"
          stroke="#fff"
          strokeWidth={0.4}
          d="m10.64 1.655-.828.31L9.717 2l-.027.096-.423 1.489-.058.204.206.046h.002l.007.002.027.006c.024.005.059.015.102.026a6.4 6.4 0 0 1 .343.1 3.425 3.425 0 0 1 .52.223l.038.02.011.006h.002l.191.103.087-.2.62-1.426.04-.095-.053-.089-.47-.773-.086-.142-.155.058Z"
        />
        <Mask
          id="f"
          width={4}
          height={4}
          x={8}
          y={1}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.4}
            d="m10.64 1.655-.828.31L9.717 2l-.027.096-.423 1.489-.058.204.206.046h.002l.007.002.027.006c.024.005.059.015.102.026a6.4 6.4 0 0 1 .343.1 3.425 3.425 0 0 1 .52.223l.038.02.011.006h.002l.191.103.087-.2.62-1.426.04-.095-.053-.089-.47-.773-.086-.142-.155.058Z"
          />
        </Mask>
        <G mask="url(#f)">
          <Path
            fill="#FECA00"
            fillRule="evenodd"
            d="m10.564 2.545-.071.079a.027.027 0 0 1-.047-.015l-.011-.106-.104-.022a.027.027 0 0 1-.01-.049l.086-.062-.034-.101a.027.027 0 0 1 .037-.033l.098.043.07-.079a.027.027 0 0 1 .048.015l.01.106.105.022c.023.005.029.035.01.049l-.086.062.033.101a.027.027 0 0 1-.037.033l-.097-.043Z"
            clipRule="evenodd"
          />
          <Path
            fill="#E31D1C"
            d="m9.498 3.244.106-.415c.47.124.96.284 1.32.438l-.164.394a9.814 9.814 0 0 0-1.262-.417Z"
          />
          <Path
            fill="#fff"
            d="m9.642 2.86.025-.103c.45.112.93.29 1.278.457l-.045.097a7.064 7.064 0 0 0-1.258-.45ZM9.508 3.288l.025-.104c.45.112.868.264 1.216.43l-.045.097a6.387 6.387 0 0 0-1.196-.423Z"
          />
          <Path
            fill="#272727"
            d="m9.712 3.088.096-.044c.04.095.091.116.175.075.198-.096.69.039.69.22 0 .07-.041.114-.104.111a.33.33 0 0 1-.128-.042.659.659 0 0 0-.104-.05l.034-.103a.687.687 0 0 1 .115.055.27.27 0 0 0 .087.032c.002 0-.005.008-.005-.003 0-.08-.4-.19-.54-.122-.139.068-.252.02-.316-.13Z"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
